import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useState, useEffect, useMemo } from "react";
import { pluck, propEq, equals, pick, pipe, map, find, prop, flatten } from "ramda";
import { Flex } from "@base-ui";
import { Accordion, FilterFieldset } from "@interdependence-ui";
import MeasurementsTable from "./table/MeasurementsTable";
import { useOrganizationsContext } from "@webapi/contexts/organizations";
import { useMeasurementsWithMetadata } from "@webapi/hooks/useMeasurementsWithMetadata";
import { measureUtils } from "utils/measurement";
import { measurementsParams } from "utils/measurementsWithMetadata";
import { addRemoveListContent } from "utils/addRemoveListContent";
import { sort, sortOrganizationIdsByPeriodValue } from "utils/sort";
import { allGenderTypes } from "utils/genders";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function TableAccordion(_ref) {
  var _query$sort;
  var measure = _ref.measure,
    query = _ref.query;
  var _useMeasurementsWithM = useMeasurementsWithMetadata(measurementsParams(query)),
    measurementsWithMetadata = _useMeasurementsWithM.measurementsWithMetadata;
  var measureMeasurementsWithMetadata = measurementsWithMetadata.get(measure.measureId) || [];
  var measurementsType = pipe(map(prop("measurements")), flatten, find(function (x) {
    return !equals(x.type, "MissingMeasure");
  }), prop("type"))(measureMeasurementsWithMetadata);
  var availableFilters = useMemo(function () {
    return measureUtils[measurementsType] || [];
  }, [measurementsType]);
  var _useOrganizationsCont = useOrganizationsContext(),
    lookupOrganization = _useOrganizationsCont.lookupOrganization;
  var _useState = useState(pluck("id", availableFilters)),
    _useState2 = _slicedToArray(_useState, 2),
    activeFilters = _useState2[0],
    setActiveFilters = _useState2[1];
  useEffect(function () {
    setActiveFilters(pluck("id", availableFilters));
  }, [availableFilters]);
  if (availableFilters.length === 0) return null;
  var filterOptions = availableFilters.map(function (x) {
    return _objectSpread(_objectSpread({}, x), {}, {
      label: "".concat(measureUtils.translateMeasurementProp[x.label], " (").concat(x.label, ")")
    });
  });
  var sortedActiveFilters = sort(function (id) {
    return availableFilters.findIndex(propEq("id"), id);
  }, activeFilters);
  var sortedOrganizations = sortOrganizationIdsByPeriodValue(lookupOrganization, ((_query$sort = query.sort) === null || _query$sort === void 0 ? void 0 : _query$sort[measure.measureId]) || query.sort, query.periodType, query.dateTo, query.units, measureMeasurementsWithMetadata);
  var genderKeys = Object.keys(allGenderTypes);
  var sortedMeasureIds = sort(function (id) {
    return genderKeys.findIndex(function (x) {
      var _measure$submeasures, _measure$submeasures$;
      return x === (measure === null || measure === void 0 ? void 0 : (_measure$submeasures = measure.submeasures) === null || _measure$submeasures === void 0 ? void 0 : (_measure$submeasures$ = _measure$submeasures.find(propEq("measureId", id))) === null || _measure$submeasures$ === void 0 ? void 0 : _measure$submeasures$.gender);
    });
  }, query.measureIds);
  return /*#__PURE__*/_jsx(Accordion, {
    id: "measurements-table",
    title: "Tabell",
    icon: "heatChart",
    children: /*#__PURE__*/_jsxs(Flex.Column, {
      children: [/*#__PURE__*/_jsx(FilterFieldset, {
        id: "column-filters",
        legend: "Filtrera kolumner",
        hideLegend: true,
        options: filterOptions,
        selected: activeFilters,
        updateSelected: addRemoveListContent(setActiveFilters, null)
      }), /*#__PURE__*/_jsx(MeasurementsTable, {
        query: query,
        activeFilters: sortedActiveFilters,
        availableFilters: availableFilters,
        measure: measure,
        organizations: sortedOrganizations,
        measureIds: sortedMeasureIds,
        measurementsWithMetadata: measureMeasurementsWithMetadata
      })]
    })
  });
}, function (prev, curr) {
  return equals(pick(["measure", "sort", "units", "periodType", "dateFrom", "dateTo", "colorSettings"], prev.query), pick(["measure", "sort", "units", "periodType", "dateFrom", "dateTo", "colorSettings"], curr.query));
});